import { render, staticRenderFns } from "./DoctorCard.vue?vue&type=template&id=d5bbc482&"
import script from "./DoctorCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./DoctorCard.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5bbc482')) {
      api.createRecord('d5bbc482', component.options)
    } else {
      api.reload('d5bbc482', component.options)
    }
    module.hot.accept("./DoctorCard.vue?vue&type=template&id=d5bbc482&", function () {
      api.rerender('d5bbc482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/profile/doctors/register/index/DoctorsRegisterContent/components/RegistrationForm/components/DoctorCard.vue"
export default component.exports